module.exports = __webpack_public_path__ + "static/logo9-5f69f990e2da03f3e34c587c8ec84e40.png";